<template>
<div class="currency-search-wrapper">
    <input
      id="search-input"
      class="search-input"
      :placeholder="placeholder"
      v-model="searchModel"
    />
    <svg
      class="search-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.7422 10.3439C12.5329 9.2673 13 7.9382 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13C7.93858 13 9.26801 12.5327 10.3448 11.7415L10.3439 11.7422C10.3734 11.7822 10.4062 11.8204 10.4424 11.8566L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L11.8566 10.4424C11.8204 10.4062 11.7822 10.3734 11.7422 10.3439ZM12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5Z"
        :fill="!themeStatus ? '#8B81A0' : '#7E7E7E'"
      />
    </svg>
</div>
</template>

<script>
    import { mapState } from "vuex";
    import { debounce } from "lodash"

    export default {
        name: "OrphanSearch",
        data() {
            return {
                search: null
            }
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
            }
        },
        computed: {
            ...mapState(['themeStatus']),
            debounceOnSearch: ({ emitSearch }) => debounce(emitSearch, 200),
            searchModel: {
              get({ value }) {
                return value
              },
              set(v) {
                this.search = v
                this.debounceOnSearch()
              }
            }
        },
        methods: {
            emitSearch() {
                this.$emit('input', this.search)
            }
        },
    }
</script>

<style lang="scss" scoped>
.currency-search-wrapper {
  position: relative;

  .search-input {
    width: 100%;
    background-color: var(--dashboard-secondary-bg-color);
    border: 1px solid var(--new-front-input-border);
    border-radius: 10px;

    color: var(--new-front-primary-font-color);

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    font-size: $h4;
    font-weight: 500;
    font-family: $Gilroy;
    height: 48px;
    padding: 0 40px 0 20px;

    &:focus, textarea:focus, select:focus {
      outline: none !important;
    }
  }
  .search-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.search-input::placeholder {
    color: var(--new-front-secondary-font-color) !important;
    font-size: $h4 !important;
    font-weight: 500 !important;
    opacity: 1;
}

@include below_phone(){
  .currency-search-wrapper {
    .search-input {
      font-size: $h5 !important;
      padding: 0 40px 0 10px;
    }
  }
  .search-input::placeholder {
    font-size: $h5 !important;
  }
}
</style>

